import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  //Logout Subscription
  beginLogoutAction: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
